export default __webpack_public_path__ + "static/media/CloudDeveloper300.2f5eef3c.jpg";